import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import XHR from 'i18next-xhr-backend';

const serviceProvider = window.$environment?.SERVICE_PROVIDER;
const appLayout = window.$environment.CURRENT_LAYOUT;
const ENGLISH_ONLY_SERVICE_PROVIDERS = ['2bro', 'tts'];
const isEnglishOnly = ENGLISH_ONLY_SERVICE_PROVIDERS.includes(serviceProvider);

const getLocaleFile = (file) => {
  try {
    return require(`globalconfig/locales/${file}/${serviceProvider}/${appLayout}`);
  } catch (error) {
    return require(`globalconfig/locales/${file}/${serviceProvider}`);
  }
};

const getLocale = (type) => {
  let translationEng = getLocaleFile('en').default;
  let translationEsp = getLocaleFile('es').default;
  let translationFra = getLocaleFile('fr').default;

  // Force English for 2Bro / TopTracking regardless of browser locale or stored preference
  if (isEnglishOnly) {
    try {
      localStorage.setItem(`${serviceProvider}Language`, 'en');
    } catch (e) {
      // ignore storage errors
    }
  }

  const i18nInstance = i18n.use(XHR);
  if (!isEnglishOnly) {
    i18nInstance.use(LanguageDetector);
  }


  i18nInstance.init({
    debug: false,
    lng: 'en',
    fallbackLng: 'en', // use en if detected lng is not available

    keySeparator: '.',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },

    resources: {
      en: {
        translations: translationEng,
      },
      ...(isEnglishOnly
        ? {}
        : {
            es: {
              translations: translationEsp,
            },
            fr: {
              translations: translationFra,
            },
          }),
    },
    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',
    ...(isEnglishOnly
      ? {
          detection: {
            order: [],
            caches: [],
          },
        }
      : {}),
  });
  return i18n;
};

export default getLocale;
